import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { InputCustomEvent, IonItem, IonList } from '@ionic/angular/standalone';

import { Address, AutocompleteService } from '@guardfinder/address';

import { SvgIconComponent } from '../../icons';
import { InputComponent } from '../input/input.component';

/// <reference types="@types/google.maps" />
@Component({
    selector: 'lib-places-autocomplete-input',
    standalone: true,
    imports: [CommonModule, InputComponent, IonList, IonItem, SvgIconComponent],
    templateUrl: './places-autocomplete-input.component.html',
    styleUrl: './places-autocomplete-input.component.css'
})
export class PlacesAutocompleteInputComponent implements OnInit {
    @Input() label: string | undefined = 'Location';
    @Input() additionalInfoLabel: string = 'Additional address info';
    @Input() placeholder!: string;
    @Input() additionalInfoPlaceholder: string = 'Enter apartment, suite, etc. (optional)';
    @Input() ionItemWrap: boolean = false;
    @Input() returnComponentsFormatted: boolean = true;
    @Input() required: boolean = false;
    @Input() inlineDropdown: boolean = true;
    @Input() noVSpacing: boolean = false;
    @Input() showLocationIcon: boolean = false;
    @Input() disabled: boolean = false;

    @Input() displayAdditionalInfoInput: boolean = false;
    @Input() additionalInfoInitialValue: string = '';

    @Input() errorText: string | undefined;

    @Output() selectedAddress = new EventEmitter<Address>();
    @Output() additionalAddressInfo: EventEmitter<string> = new EventEmitter();

    @ViewChild('autocompleteInput') autocompleteInput!: InputComponent;
    @ViewChild('additionalInfoInput') additionalInfoInput!: InputComponent;

    displayDropdown: boolean = false;

    autocompleteSuggestionsList: Address[] = [];

    inputValue: string = '';
    additionalInfoValue: string = '';

    chosenAddress?: Address;

    isLoading: boolean = false;

    googleLogoUrl: string = '../../../assets/google_logo/google_on_white.png';

    constructor(private readonly autocompleteService: AutocompleteService) {}

    ngOnInit(): void {
        this.init().then();
    }

    async init() {
        if (this.required) {
            this.autocompleteInput.required = true;
        }
    }

    markAsTouched() {
        this.autocompleteInput.markAsTouched();
    }

    onBlur() {
        if (!this.inlineDropdown) {
            setTimeout(() => {
                this.displayDropdown = false;
            }, 100);
        }
    }

    onFocus() {
        this.displayDropdown = true;
    }

    onInput(event: CustomEvent) {
        this.displayDropdown = true;

        const value = event.detail.value;
        this.inputValue = value;

        this.isLoading = true;

        this.chosenAddress = undefined;
        this.selectedAddress.emit(undefined);

        if (value) {
            this.autocompleteSearch(value).then();
            return;
        }
        this.autocompleteSuggestionsList = [];
        this.isLoading = false;
    }

    async onAddressSelect(address: Address) {
        this.chosenAddress = address;
        this.autocompleteInput.setValue(address.formattedAddress);

        this.autocompleteSuggestionsList = [];
        this.additionalInfoValue = '';
        this.additionalInfoInput.input.value = '';

        this.displayDropdown = false;

        this.selectedAddress.emit(address);
    }

    async autocompleteSearch(value: string) {
        this.autocompleteSuggestionsList = await this.autocompleteService.getAutoCompleteAddresses(value);
        this.isLoading = false;
    }

    onAdditionalInfoInput(event: InputCustomEvent) {
        this.additionalInfoValue = event.detail.value || '';
        this.additionalAddressInfo.emit(event.detail.value || '');
    }
}
